import '../../components/styles/PharmacovigilanceCommittee.css';
import '../../components/styles/CommitteeTable.css';

const CurriculumCommittee = () => {
  const members = [
    { sl: 1, name: 'Dr. M Jayasree', designation: 'Dean & Chairman, Professor, Department of Obstetrics and Gynaecology', position: 'Chairperson', mobile: '9443769196', email: 'jayasreevyshali@gmail.com' },
    { sl: 2, name: 'Dr. G Ramya', designation: 'MEU Coordinator, Professor and Head, Department of Pathology', position: 'MEU Co-ordinator', mobile: '9443770713', email: 'pondysaleem@gmail.com' },
    { sl: 3, name: 'Dr. C Prasath', designation: 'Medical Superintendent & Professor, Department of Anaesthesiology', position: 'Member', mobile: '9840579316', email: 'trishpraveen@gmail.com' },
    { sl: 4, name: 'Dr. T Vignesh', designation: 'Associate Professor, Department of Community Medicine', position: 'Member', mobile: '9500469234', email: 'vickytamilchelvan@gmail.com' },
    { sl: 5, name: 'Dr. Dhibika M', designation: 'Assistant Professor, Department of Microbiology', position: 'Member', mobile: '9944265678', email: 'dhib.doc17@gmail.com' },
    { sl: 6, name: 'Dr. J S Arun kumar', designation: 'Professor & Head, Department of Forensic Medicine & Toxicology', position: 'Member', mobile: '9486113128', email: 'dr.arunjs.forensic@gmail.com' },
    { sl: 7, name: 'Dr. A Arthy', designation: 'Associate Professor, Department of Forensic Medicine & Toxicology', position: 'Member', mobile: '8447662259', email: 'arthy2712@gmail.com' },
    { sl: 8, name: 'Dr. S Pravinraj', designation: 'Associate Professor, Department of Community Medicine', position: 'Member', mobile: '9790205705', email: 'adroitpravin@gmail.com' },
    { sl: 9, name: 'Dr. S Sumathy', designation: 'Professor & Head, Department of Biochemistry', position: 'Member', mobile: '9443344381', email: 'biomathy11@gmail.com' },
    { sl: 10, name: 'Dr. T Bhuvaneswari', designation: 'Professor & Head, Department of Physiology', position: 'Member', mobile: '8825909195', email: 'drbhuvanathangavel@gmail.com' },
    { sl: 11, name: 'Dr. S Nitya', designation: 'Professor & HOD, Department of Pharmacology', position: 'Member', mobile: '9787679839', email: 'dmityapharm@gmail.com' },
    { sl: 12, name: 'Dr. R Divya Bharathy', designation: 'Assistant Professor, Department of Community Medicine', position: 'Member', mobile: '7094344720', email: 'drdivyabharathy@gmail.com' },
    { sl: 13, name: 'Dr. G Aravindraj', designation: 'Assistant Professor, Department of Orthopedics', position: 'Member', mobile: '9597092878', email: 'rajaravind148@gmail.com' },
    { sl: 9, name: 'N.A. students in Phase I only', designation: 'Student Rep from Phase III', position: 'Student Representative', mobile: '', email: '' },
  ];

  const pdfPath = '/assets/document/committee/curriculam-commitee/Curriculam Commitee Members.pdf';

  return (
    <div className="pharma-container">
      <header className="pharma-header">
        <h1>Curriculum Committee - 2025</h1>
      </header>

      <section className="pharma-description">
        <p>
          The Curriculum Committee ensures a structured and updated academic curriculum, aligning
          with regulatory bodies and modern medical education standards. It continuously reviews
          and revises syllabi to enhance student learning outcomes and maintains compliance with
          NMC guidelines.
        </p>
      </section>

      <section className="pharma-table-section">
        <div className="ct-table-wrapper">
          <table className="pharma-table ct-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Position</th>
                <th>Mobile No.</th>
                <th>Email ID</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m, i) => (
                <tr key={i}>
                  <td className="ct-sl" data-label="Sl.">{i + 1}</td>
                  <td data-label="Name">{m.name}</td>
                  <td data-label="Designation">{m.designation}</td>
                  <td data-label="Position">{m.position}</td>
                  <td className="ct-nowrap" data-label="Mobile">{m.mobile}</td>
                  <td className="ct-email" data-label="Email">{m.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <div className="ct-doc-btn-wrap">
        <a href={`/view-document.html?file=${encodeURIComponent(pdfPath)}`} target="_blank" rel="noopener noreferrer" className="ct-doc-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="12" y1="18" x2="12" y2="12"/>
            <line x1="9" y1="15" x2="15" y2="15"/>
          </svg>
          View Official Document
        </a>
      </div>
    </div>
  );
};

export default CurriculumCommittee;
